var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandbook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.001 1.25538C27.2646 1.25538 28.2738 1.46872 28.8974 1.65744V18.2564C28.2821 18.1497 27.6092 18.1005 26.9036 18.1005C23.5477 18.1005 19.839 19.2738 17.7056 20.0615V4.34051C20.3641 2.28923 23.1538 1.25538 26.001 1.25538ZM26.001 0C23.4985 0 20.0933 0.754872 16.4503 3.73333V21.9077C16.4503 21.9077 22.1364 19.3395 26.9036 19.3395C28.0769 19.3395 29.1846 19.4954 30.1528 19.881V0.771282C30.1446 0.771282 28.5364 0 26.001 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04818 1.23897C10.8215 1.23897 13.5292 2.27282 16.122 4.3241V20.0697C14.0379 19.2738 10.4359 18.1169 7.17023 18.1169C6.48921 18.1169 5.841 18.1662 5.24203 18.2728V1.63282C5.84921 1.45231 6.82562 1.23897 8.04818 1.23897ZM8.04818 0C5.57844 0 4.00305 0.771282 4.00305 0.771282V19.881C4.93844 19.4954 6.02972 19.3395 7.17023 19.3395C11.8143 19.3395 17.361 21.9077 17.361 21.9077V3.73333C13.8082 0.754872 10.4933 0 8.04818 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00308 2.69971H1V23.1551C1 23.1551 6.76 19.3971 17.6974 21.8012",
    stroke: "white",
    strokeWidth: 1.5258,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.997 2.69971H33V23.1551C33 23.1551 27.24 19.3971 16.3026 21.8012",
    stroke: "white",
    strokeWidth: 1.5258,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbook);
export default __webpack_public_path__ + "static/media/handbook.7ff6a216.svg";
export { ForwardRef as ReactComponent };